export const STEPS = {
  ABOUT_YOU: 'About you',
  CHOOSE_THE_COVER: 'Choose the cover',
  EXTRAS_SERVICES: 'Extras services',
  HOSPITAL_SERVICES: 'Hospital services',
  SPLASH_SCREEN: 'Splash screen',
};

export const analyticsLabels = {
  [STEPS.ABOUT_YOU]: 'About',
  [STEPS.CHOOSE_THE_COVER]: 'Choose cover',
  [STEPS.EXTRAS_SERVICES]: 'Extras',
  [STEPS.HOSPITAL_SERVICES]: 'Hospital',
};
